import { X, Download } from "lucide-react";

/**
 * Simple in-browser PDF viewer using an iframe.
 * Modern browsers natively render PDFs; a Download fallback is provided.
 */
export default function PdfViewer({ url, title, onClose }) {
  if (!url) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={onClose} data-testid="pdf-viewer">
      <div
        className="bg-white w-full max-w-6xl h-[92vh] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-[var(--line)] bg-[var(--navy)] text-white">
          <div>
            <div className="text-[10px] tracking-widest text-[var(--gold)] font-bold">VIEW ONLINE</div>
            <div className="font-display text-lg" data-testid="pdf-viewer-title">{title}</div>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={url}
              download
              className="inline-flex items-center gap-2 px-3 py-2 border border-[var(--gold)] text-[var(--gold)] text-[11px] font-bold tracking-widest hover:bg-[var(--gold)] hover:text-[var(--navy)] transition-colors"
              data-testid="pdf-viewer-download"
            >
              <Download size={12} /> DOWNLOAD
            </a>
            <button
              onClick={onClose}
              className="w-10 h-10 grid place-items-center border border-neutral-500 hover:border-white hover:bg-[var(--navy-2)]"
              aria-label="Close"
              data-testid="pdf-viewer-close"
            >
              <X size={16} />
            </button>
          </div>
        </div>
        <iframe
          src={`${url}#toolbar=1&navpanes=1&view=FitH`}
          className="flex-1 w-full border-0 bg-neutral-200"
          title={title}
        />
      </div>
    </div>
  );
}
